export default __webpack_public_path__ + "static/img-art-pandas-profiling-3-52c9b56e1bfd5fe0923a1c77f35766fb.png";